import { equaldate } from "@/utils/rsql";

export default {
  proposalNumber: {
    filterPath: "proposal.number",
  },

  proposalSource: {
    filterPath: "proposal.source.value",
  },

  proposalType: {
    filterPath: "proposal.procedureType.value",
  },

  status: {
    filterPath: "status",
  },

  proposalName: {
    filterPath: "proposal.procedureName",
  },

  lotsNumber: {
    filterPath: "proposal.numberLots",
    type: "number",
  },

  lot: {
    filterPath: "name",
  },

  quantity: {
    filterPath: "quantity",
  },

  price: {
    filterPath: "price",
    type: "decimal",
  },

  currency: {
    filterPath: "currency",
  },

  expirationDays: {
    filterPath: "proposal.endDate",
    type: "number",
    operation: equaldate,
  },

  organization: {
    filterPath: "proposal.organization",
  },

  startDate: {
    filterPath: "proposal.startDate",
    type: "date",
  },

  endDate: {
    filterPath: "proposal.endDate",
    type: "date",
    operation: equaldate,
  },

  place: {
    filterPath: "place",
  },

  deliveryTime: {
    filterPath: "deliveryTime",
  },

  contacts: {
    filterPath: "proposal.contact",
  },

  unp: {
    filterPath: "proposal.UNP",
  },

  source: {
    filterPath: "source",
  },

  paymentMethod: {
    filterPath: "paymentMethod",
  },

  paymentForBroker: {
    filterPath: "proposal.paymentForBroker",
  },

  codeOKRB: {
    filterPath: "codeOKRB",
  },

  documents: {
    filterPath: "proposal.docs.name",
  },

  sector: {
    filterPath: "proposal.sector.value",
  },
};
